<template>
  <ul class="flex flex-row items-center pagination">
    <li
      class="inline-block mr-1 pagination __back"
      :class="{'--disabled': !hasPrev}"
    >
      <a
        class="cursor-pointer"
        :class="{'pointer-events-none': !hasPrev }"
        @click="changePage(value - 1)"
      >
        <aha-icon
          width="16"
          height="16"
          viewBox="0 0 24 24"
          name="arrow"
        />
      </a>
    </li>
    <!-- Case page totalPages <= 5 -->
    <span class="pagination __content" v-if="totalPages <= 5">
      <li
        class="inline-block mr-1 pagination __page"
        v-for="index in totalPages"
        :class="{'--active': index === value }"
        :key="index"
      >
        <a
          class="cursor-pointer"
          @click="changePage(index)"
        >
          {{ index }}
        </a>
      </li>
    </span>
    <span class="pagination __content" v-else>
      <!-- Case page totalPages > 5 -->
      <li
        class="inline-block mr-1 pagination __page"
        :class="{'--active': value === 1 }"
      >
        <a
          class="cursor-pointer"
          @click="changePage(1)"
        >
          1
        </a>
      </li>

      <!-- Case close to left edge -->
      <span v-if="value === 1 || value === 2">
        <li
          class="inline-block mr-1 pagination __page"
          :class="{'--active': value === 2 }"
        >
          <a
            class="cursor-pointer"
            @click="changePage(2)"
          >
            2
          </a>
        </li>
        <li
          class="inline-block mr-1 pagination pagination __page"
          :class="{'--active': value === 3 }"
        >
          <a
            class="cursor-pointer"
            @click="changePage(3)"
          >
            3
          </a>
        </li>
        <li
          class="inline-block mr-1 pagination __page"
          :class="{'--active': value === 4 }"
        >
          <a
            class="cursor-pointer"
            @click="changePage(4)"
          >
            4
          </a>
        </li>
        <li
          class="inline-block mr-1 pagination __dots"
        >
          ...
        </li>
      </span>
      <!-- Case close to right edge  -->
      <span
        v-else-if="value === totalPages - 2 || value === totalPages - 1 || value === totalPages"
      >
        <li
          class="inline-block mr-1 pagination __dots"
        >
          ...
        </li>
        <li
          class="inline-block mr-1 pagination __page"
          :class="{'--active': value === totalPages - 3 }"
        >
          <a
            class="cursor-pointer"
            @click="changePage(totalPages - 3)"
          >
            {{ totalPages - 3 }}
          </a>
        </li>
        <li
          class="inline-block mr-1 pagination __page"
          :class="{'--active': value === totalPages - 2 }"
        >
          <a
            class="cursor-pointer"
            @click="changePage(totalPages - 2)"
          >
            {{ totalPages - 2 }}
          </a>
        </li>
        <li
          class="inline-block mr-1 pagination __page"
          :class="{'--active': value === totalPages - 1 }"
        >
          <a
            class="cursor-pointer"
            @click="changePage(totalPages - 1)"
          >
            {{ totalPages - 1 }}
          </a>
        </li>
      </span>
      <!-- other cases in the middle, not close to any edge -->
      <span v-else>
        <li
          v-show="value !== 1"
          class="inline-block mr-1 pagination __dots"
        >
          ...
        </li>
        <li
          class="inline-block mr-1 pagination __page  --active"
        >
          <a
            class="cursor-pointer"
            @click="changePage(value)"
          >
            {{ value }}
          </a>
        </li>
        <li
          class="inline-block mr-1 pagination __page"
        >
          <a
            class="cursor-pointer"
            @click="changePage(value + 1)"
          >
            {{ value + 1 }}
          </a>
        </li>
        <li
          class="inline-block mr-1 pagination __dots"
        >
          ...
        </li>
      </span>
      <li
        class="inline-block mr-1 pagination __page"
        :class="{'--active': value === totalPages }"
      >
        <a
          class="cursor-pointer"
          @click="changePage(totalPages)"
        >
          {{ totalPages }}
        </a>
      </li>
    </span>
    <li
      class="inline-block mr-1 pagination __next"
      :class="{'--disabled': !hasNext}"
    >
      <a
        class="cursor-pointer"
        :class="{'pointer-events-none': !hasNext }"
        @click="changePage(value + 1)"
      >
        <aha-icon
          width="16"
          height="16"
          viewBox="0 0 24 24"
          name="arrow"
        />
      </a>
    </li>
  </ul>
</template>

<script>
import AhaIcon from './Icon.vue'

export default {
  components: {
    AhaIcon,
  },
  props: {
    value: {
      type: Number,
      default: 1,
    },
    totalRows: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 50,
    },
  },
  data() {
    return {}
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage)
    },
    hasPrev() {
      return this.value > 1
    },
    hasNext() {
      return this.value < this.totalPages
    },
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.$emit('input', page)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pagination {
  &.__content {
    background: #FFFFFF;
    padding: 10px 0;
  }

  &.__page {
    border-radius: 4px;
    width: 22px;
    height: 22px;

    &.--active {
      background: #348EF6;
      box-shadow: 0px 2px 4px rgba(79, 155, 243, 0.2);

      & > a {
        @apply text-base-0 font-bold;

        &:hover {
          color: #fff !important;
        }
      }
    }

    &:hover > a {
      @apply text-primary-90;
    }
  }

  &.__page > a {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 22px;
    @apply text-base-90;
  }

  &.__back, &.__next {
    &.--disabled > a {
      @apply text-base-60;
    }
  }

  &.__back {
    margin-right: 8px;
    transform: rotate(90deg);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.__next {
    margin-left: 8px;
    transform: rotate(-90deg);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
